import MobileTabs from './MobileTabs';
import SubTabs from './SubTabs';
import Tabs from './Tabs';
import Switch from './Swtich';

export { MobileTabs, SubTabs, Tabs, Switch };
export default { MobileTabs, SubTabs, Tabs, Switch };
